"use client";

import { c as _c } from "react/compiler-runtime";
import type { FieldErrors, UseFormRegister } from "react-hook-form";
import { Textarea } from "@/components/ui/textarea";
import type { ProposalFormValues } from "@/lib/proposal";
type ProposalStepDetailsProps = {
  errors: FieldErrors<ProposalFormValues>;
  register: UseFormRegister<ProposalFormValues>;
};
export function ProposalStepDetails(t0) {
  const $ = _c(10);
  const {
    errors,
    register
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <label className="sr-only" htmlFor="note">Detalhes do projeto</label>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== register) {
    t2 = register("note");
    $[1] = register;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <Textarea {...t2} className="min-h-42 w-full resize-none rounded-lg border-0 bg-gray-350 px-5 py-4 font-manrope text-[14px] leading-6 text-white shadow-none placeholder:text-[#dcdcdc] focus-visible:ring-1 focus-visible:ring-white/15" data-proposal-animate={true} id="note" placeholder="Detalhes do projeto" />;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== errors.note) {
    t4 = errors.note && <p className="mt-2 text-sm text-red-300" data-proposal-animate={true}>{errors.note.message}</p>;
    $[5] = errors.note;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3 || $[8] !== t4) {
    t5 = <div>{t1}{t3}{t4}</div>;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}